/* eslint-disable max-len */
import React from 'react';
function Copy() {
    return (React.createElement("g", null,
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5 1H17V3H5V17H3V3C3 1.9 3.9 1 5 1ZM20 5H9C7.9 5 7 5.9 7 7V21C7 22.1 7.9 23 9 23H20C21.1 23 22 22.1 22 21V7C22 5.9 21.1 5 20 5ZM20 21H9V7H20V21Z" })));
}
export default Copy;
